// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"96546a0b","455":"8d26a71e"}[chunkId] + ".chunk.js";
};